module.exports = __webpack_public_path__ + "static/media/mock-culbot2.f8e6a85f.png";